// extracted by mini-css-extract-plugin
export default {"container":"OTPInput_container__Yw5Cs","wrapperInput":"OTPInput_wrapperInput__fAo6F","inputOTP":"OTPInput_inputOTP__SAj3g"};